import { get } from "./helper";

const _showIntersects = function(component)
{
    if(!!component.$children && component.$children.length > 0)
    {
        component.$children.forEach(childComponent =>
        {
            if(childComponent.$options.name === "intersect")
            {
                childComponent.isVisible = true;
            }
            _showIntersects(childComponent);
        });
    }
};

Vue.component("cytQuickshopOverlay", {

    template: "#cyt-quickshop-overlay",

    provide()
    {
        const self = this;
        const providedData = {};
        Object.defineProperty(providedData, "itemId", {
            enumerable: true,
            get: function() {
                return self.itemId
            }
        });

        return providedData;
    },

    props:
    {
        title: {
            type: String,
            required: false
        }
    },

    data()
    {
        return {
            isLoading: false,
        };
    },

    mounted()
    {
        const $modal = jQuery(this.$el);
        const originalFilterFn = this.$root.$options.filters.itemURL;
        const self = this;

        $modal.on("shown.bs.modal", () =>
        {
            vueApp.$options.filters.itemURL = function(itemData, keepVariationId) {
                if( self.itemId === itemData.item.id ) {
                    return window.location.pathname;
                }

                return originalFilterFn(itemData, keepVariationId);
            }
        });

        $modal.on("hide.bs.modal", () =>
        {
            vueApp.$options.filters.itemURL = originalFilterFn;
        });

        document.addEventListener("afterBasketItemAdded", () =>
        {
            $modal.modal("hide");
        });

        this.$store.commit("setOnLoadingStart", () => {
            this.isLoading = true;
            if(!!this.$slots.loading) {
                $modal.modal("show");
            }
        });

        this.$store.commit("setOnLoadingDone", () => {
            this.isLoading = false;
            if(!this.$slots.loading) {
                $modal.modal("show");
            }
            this.$nextTick(() =>
            {
                _showIntersects(this);
            });
        });
    },

    methods:
    {
        getDataField(field)
        {
            return get(this.variation, field);
        },

        getFilteredDataField(field, filter)
        {
            if (!!this.$options.filters[filter])
            {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        }
    },

    computed:
    {
        variation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },
        ...Vuex.mapState({
            itemId: state => state.cytQuickshopOverlay.overlayItemId
        })
    }
});
